import { Injectable, inject } from '@angular/core';
import {
  DocumentManagementApi,
  type DocumentDetailResponse,
  type FolderDetailResponse,
  type StarredListResponse,
} from '@tourfold/libraries/tf-api-client-public-v2';

/**
 * Thin wrapper over the per-user star endpoints. Backend lists do not carry the per-row `starred`
 * flag (it would require a per-row lookup), so callers fetch the user's full starred set via
 * {@link listAll} once and intersect by id when rendering rows.
 *
 * Toggle endpoints are idempotent on the server — re-starring a starred entry is a no-op and
 * returns the unchanged detail. Callers can therefore treat the response as the source of truth
 * for the new state and use the value directly without an extra GET.
 */
@Injectable({ providedIn: 'root' })
export class StarsService {
  private readonly api = inject(DocumentManagementApi);

  listAll(): Promise<StarredListResponse> {
    return this.api.listStarred({});
  }

  starFolder(id: string): Promise<FolderDetailResponse> {
    return this.api.starFolder({ id });
  }

  unstarFolder(id: string): Promise<FolderDetailResponse> {
    return this.api.unstarFolder({ id });
  }

  starDocument(id: string): Promise<DocumentDetailResponse> {
    return this.api.starDocument({ id });
  }

  unstarDocument(id: string): Promise<DocumentDetailResponse> {
    return this.api.unstarDocument({ id });
  }
}
